import { type UUID } from '~/types/common';

import { type KyRequestOptions } from '@vestigas/data';

import { fetchInvoiceFile } from '../useQueryInvoiceFile';

export const INVOICE_PDF_FILE_TYPE = 'processed_pdf' as const;

/**
 * Fetches the PDF file for a specific invoice by ID.
 *
 * @param invoiceId - The ID of the invoice to fetch the PDF for.
 * @param options - The options for the request (includes abort signal).
 * @returns The invoice PDF as a Blob.
 * @throws Error if the API request fails.
 * @see https://app.dev.vestigas.com/redoc#tag/Delivery-Note/operation/get_invoice_pdf_asset_invoice__id__pdf_get
 */
export const fetchInvoicePdf = async (
  invoiceId: UUID,
  options?: KyRequestOptions,
) => {
  return fetchInvoiceFile(
    {
      fileType: INVOICE_PDF_FILE_TYPE,
      invoiceId,
    },
    options,
  );
};
